var map = {
	"./1.jpg": "580e",
	"./codremap-card.png": "d445",
	"./duckount-card.png": "9bf4",
	"./evergreen-card.jpg": "785f",
	"./findwords-card.jpg": "4bcc",
	"./forest-me.jpg": "37fc",
	"./forestMe1.jpg": "8e65",
	"./kcdcox-card.jpg": "388d",
	"./lightright.png": "71c7",
	"./noisyTexture.png": "b58d",
	"./sarisha-card.png": "1746"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3969";